"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Biv;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Biv(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.8 315.3"
  }, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".st0{fill:#333333;}"
    }
  }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    className: "st0",
    d: "M1.8,170.3c-2.3-8.7-2.6-18.1,0.6-26.6c2.4-6.8,6.9-12.6,12.2-17.4c37.3-35.1,79-66,124.9-89.1 C181.9,15.9,228.3,1.4,276,0.1c42-1.3,83.9,8.2,122.6,24c57.5,23.7,109.1,60.2,154.2,102.7c4.4,4.1,8.2,8.9,10.6,14.4 c5.8,12.9,4.1,28.9-4.4,40.3c-3.9,5.1-8.9,9.2-13.5,13.6c-29.2,26.8-61.1,50.8-95.4,70.6c-32.8,18.9-68,34-105,42.4 c-24.6,5.6-50,8-75.2,6.8c-44.2-2.4-87.4-15.6-126.9-35.2c-40-19.6-76.8-45.4-110.5-74.6C32.5,205.2,5,181.7,1.8,170.3z M257.5,21.4c-37.4,4-73.5,16.1-107.1,32.7c-45.1,22.6-86.2,52.8-122.7,87.5c-4.4,3.8-7.7,9.2-7.7,15.2c-0.3,5.6,1.8,11.2,5.7,15.1 c19.9,19.4,41.4,37,64.1,53.1c34.6,24.3,72.2,44.8,112.7,57.4c38.1,12.1,78.9,16.3,118.5,10.1c42.8-6.5,83.5-23.2,120.8-44.9 c35.8-21,68.9-46.5,98.8-75.3c6.3-5.8,8-15.7,4.3-23.4c-2.6-5.5-7.9-8.9-11.9-13.2c-42.2-38.7-90.1-72-143.3-93.6 C348,25.1,302.4,16.4,257.5,21.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "st0",
    d: "M269,36.8c24.4-3,49.7,1.7,71.3,13.3c31.3,16.4,54.7,47.1,62,81.6c5.2,24.2,3,49.9-6.6,72.7 c-12.7,30.7-38.6,55.8-69.8,67.3c-23.5,8.9-49.8,10.1-74.1,3.5c-33.5-8.8-62.5-32.8-77.7-63.9c-13.8-27.5-16.3-60.4-7.1-89.7 c6.2-20.1,17.9-38.5,33.2-52.9C219,51.2,243.4,39.6,269,36.8z M273.5,56.4c-29.7,2.8-57.7,19.5-74.3,44.3 c-15.2,22.1-20.9,50.5-15.5,76.8c3.9,20,14.1,38.7,28.8,52.9c13.1,12.9,29.8,22.1,47.6,26.3c23,5.5,47.8,2.6,68.9-8.1 c29.2-14.5,50.5-43.7,55.1-76c3.4-22.9-1.3-47-13.3-66.9c-8.9-15.2-22-27.8-37.3-36.5C315.5,58.8,294.2,54.4,273.5,56.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "st0",
    d: "M275.4,112.4c17.8-3.3,36.8,5.1,46.5,20.2c8.6,13.1,9.8,30.8,2.8,44.9c-7.3,15.4-23.7,26.1-40.8,26 c-15.1,0.4-29.9-7.4-38.4-19.8c-7.3-10.5-9.9-24.1-6.9-36.6C242.5,129.6,257.7,115.3,275.4,112.4z"
  })));
}